import { inject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { ExportService } from 'pages/utilities/exports/service';
import { ProcessService } from 'pages/standard-setup/processes/service';
import { MachineService } from 'pages/standard-setup/machines/service';

@inject(DialogController, ExportService, ProcessService, MachineService)
export class ProcessExport {
    constructor(controller, exportService, processService, machineService) {
        this.controller = controller;
        this.exportService = exportService;
        this.processService = processService;
        this.machineService = machineService;

        this.type = 'processes';

        this.filter = {
            workcenter: null,
            processId: null,
            machineId: null
        }
    }

    changeWorkCenter() {      
        this.filter.processId = null;
        this.processSelect.select.clear(true);
        this.item.machineId = null;
        this.machineSelect.select.clear(true);
    }

    async export() {
        if (this.type == 'processes') {
            await this.exportNormal();
        } else {
            await this.exportOverriden();
        }
    }

    async exportNormal() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const workCenter = this.filter.workCenter ?? "STAMPING";
        const machineId = this.filter.machineId ?? 0;
        const processId = this.filter.processId ?? 0;
        
        await this.exportService.exportProcessRecords(workCenter, processId, machineId);

        this.isRequesting = false;
        this.controller.ok();
    }

    async exportOverriden() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const workCenter = this.filter.workCenter ?? "STAMPING";
        const machineId = this.filter.machineId ?? 0;
        const processId = this.filter.processId ?? 0;
        
        await this.exportService.exportOverriddenProcessRecords(workCenter, processId, machineId);

        this.isRequesting = false;
        this.controller.ok();
    }
}